export const registerPageModule = async (store, module, namespace) => {
    if (store && !store.hasModule(namespace)) {
        await store.registerModule(namespace, module)

        // Update store's initial state
        const initState = await store.$storage.getItem('initialState')

        if (initState) {
            initState[namespace] = module.state()
            await store.$storage.setItem('initialState', initState)
        }
    }
}